import {useSignal} from '@preact/signals-react'
import {useSignals} from '@preact/signals-react/runtime'
import {Button} from 'primereact/button'
import {Dialog} from 'primereact/dialog'
import {forwardRef, useImperativeHandle} from 'react'
import TranslateUtils from '../../i18n/TranslateUtils'
import {
    blockOverflownScroll,
    unblockOverflownScroll,
} from '../../utils/BlockScrollsUtils'

const WatchDialog = forwardRef((props, ref) => {
    useSignals()
    const {translateCommons} = TranslateUtils()
    useImperativeHandle(ref, () => ({
        showForm: handleShowForm,
        hideForm: handleHideForm,
    }))

    const visible = useSignal(false)

    const handleShowForm = () => {
        blockOverflownScroll()
        visible.value = true
    }

    const handleHideForm = () => {
        unblockOverflownScroll()
        visible.value = false
    }

    return (
        <Dialog
            header={
                <h5 className="mb-0 font-bold">
                    <strong>{translateCommons('Sync Data Information')}</strong>
                </h5>
            }
            visible={visible.value}
            blockScroll
            onHide={() => handleHideForm()}
            style={{width: '40vw'}}
            breakpoints={{'960px': '75vw', '641px': '100vw'}}>
            <div
                className="mb-5"
                style={{
                    zIndex: 99999,
                }}>
                <h4>
                    {translateCommons('- Scenario 1: The watch face is')}
                    <span className="text-primary font-bold">
                        {translateCommons('active')}
                    </span>
                </h4>
                <b className="ml-2 text-lg">
                    {translateCommons(
                        'In about 2 - 3 minutes, you will receive the newest synced data',
                    )}
                </b>
                <h4>
                    {translateCommons('- Scenario 2: The watch face is')}
                    <span className="font-bold" style={{color: 'red'}}>
                        {translateCommons('inactive')}
                    </span>
                </h4>
                <b className="ml-2 text-lg">
                    {translateCommons(
                        'In about 5 - 6 minutes, you will receive the newest synced data',
                    )}
                </b>
            </div>
            <div className="col-12 py-3">
                <Button
                    label={translateCommons('Yes, I understand')}
                    onClick={handleHideForm}
                    icon={'pi pi-send'}
                    className="col-12 p-button-lg font-bold bg-teal-600 border-0"
                />
            </div>
        </Dialog>
    )
})

export default WatchDialog
